import axios, { Canceler } from "axios";
import {responseSuccessInterceptor} from "./interceptors";
import environment from "../environment";
import AuthService from "./AuthService";
import StorageService from "./StorageService";
import tokenMonitor from "../utils/tokenMonitor";
import routes from "../routes/public.routes";

let cancel: Canceler;
const BaseApi = axios.create({
  baseURL: environment.api,
});

let isRefreshing = false;
let failedQueue: any[] = [];

//Função para fila de requisições:
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

// INTERCEPTOR DE REQUISIÇÕES:
BaseApi.interceptors.request.use(async (config) => {
  const token = StorageService.getToken();
  const refreshToken = StorageService.getRefreshToken();

  const validToken = await tokenMonitor(token ?? "", refreshToken ?? "");

  if (validToken) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${validToken}`;
  } else {
    const isPublicRoute = routes.some((route) =>
      window.location.pathname.startsWith(route.path)
    );
    if(isPublicRoute){
      return config;
    }

    if (cancel) {
      cancel("Request cancelled");
    }

    config.cancelToken = new axios.CancelToken((c) => {
      cancel = c;
    });
  }

  return config;
});

// INTERCEPTOR DE RESPONSES:
BaseApi.interceptors.response.use(responseSuccessInterceptor, async (error) => {
  const originalRequest = error.config;

  // Verifica se response deu erro, e se é 401
  if (
    error.response &&
    error.response.status === 401 &&
    !originalRequest._retry
  ) {
    originalRequest._retry = true;

    // Verifica validade do token e refresh
    const token = StorageService.getToken();
    const refreshToken = StorageService.getRefreshToken();

    const validToken = await tokenMonitor(token ?? "", refreshToken ?? "");

    // Se token e refresh expiraram, desloga e para requisições:
    if (!validToken) {
      StorageService.logOutForLogin();
      return Promise.reject(error);
    }

    // Se o token foi renovado, refaz a requisição original
    if (!isRefreshing) {
      isRefreshing = true;

      try {
        const { data } = await AuthService.refreshToken();
        const newToken = data.token;

        // Autentica novo token
        axios.defaults.headers["Authorization"] = `Bearer ${newToken}`;
        processQueue(null, newToken);
        isRefreshing = false;

        // Refaz a requisição original
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return BaseApi(originalRequest);
      } catch (err) {
        processQueue(err, null);
        isRefreshing = false;
        return Promise.reject(err);
      }
    }

    // Aguarda na fila até renovaçao do token:
    return new Promise<string>((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then((token: string) => {
      originalRequest.headers["Authorization"] = `Bearer ${token}`;
      return BaseApi(originalRequest);
    });
  }

  if(error.response){
    console.log(error.response);
  }
  

  return Promise.reject(error);
});

export default BaseApi;
